import { Component } from '@angular/core';

@Component({
  selector: 'app-in-admin',
  templateUrl: './in-admin.component.html',
  styleUrls: ['./in-admin.component.scss']
})
export class InAdminComponent {

}
